import { oktaAuth } from '../config/oktaConfig';
import log from '../logger';
const getWorkspaceConfig = () => {
    const config = {
        baseUrl: process.env.REACT_APP_WORKSPACE_API_BASE_URL || '',
        namespace: process.env.REACT_APP_WORKSPACE_NAMESPACE || ''
    };
    if (!config.baseUrl)
        log.warn('REACT_APP_WORKSPACE_API_BASE_URL is empty');
    if (!config.namespace)
        log.warn('REACT_APP_WORKSPACE_NAMESPACE is empty');
    return config;
};
export const fetchSavedViews = async (userEmail) => {
    // Safety check: Don't make API call without userEmail to prevent data leaks
    if (!userEmail) {
        log.warn('fetchSavedViews called without userEmail - returning empty array to prevent data leak');
        return [];
    }
    const { baseUrl, namespace } = getWorkspaceConfig();
    try {
        const accessToken = oktaAuth.getAccessToken();
        if (!accessToken) {
            throw new Error('No access token available. User may not be authenticated.');
        }
        const apiUrl = `${baseUrl}/projects/v1/namespace/${namespace}`;
        const url = new URL(apiUrl);
        url.searchParams.append('memberId', userEmail);
        const response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }
        const savedViewData = await response.json();
        return savedViewData;
    }
    catch (error) {
        console.error('Error fetching user projects:', error);
        throw error;
    }
};
export const createProject = async (projectData) => {
    const { baseUrl, namespace } = getWorkspaceConfig();
    try {
        const accessToken = oktaAuth.getAccessToken();
        if (!accessToken) {
            throw new Error('No access token available. User may not be authenticated.');
        }
        const { linePlanEntityType, metadata, ...rest } = projectData;
        const wrappedMetadata = {
            version: 1,
            viewType: 'grid',
            linePlanEntityType: linePlanEntityType || 'model',
            gridState: metadata
        };
        const requestData = {
            ...rest,
            metadata: wrappedMetadata,
            namespace: projectData.namespace || namespace
        };
        const url = `${baseUrl}/projects/v1`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(requestData)
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error('Error creating project:', error);
        throw error;
    }
};
export const deleteSavedView = async (savedViewId) => {
    const { baseUrl } = getWorkspaceConfig();
    try {
        const accessToken = oktaAuth.getAccessToken();
        if (!accessToken) {
            throw new Error('No access token available. User may not be authenticated.');
        }
        const url = `${baseUrl}/projects/v1/${savedViewId}`;
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({ status: false })
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }
        log.info(`Successfully deleted saved view with ID: ${savedViewId}`);
    }
    catch (error) {
        console.error('Error deleting saved view:', error);
        throw error;
    }
};
